export const getNavigationPath = (path) => {
	const uid = localStorage.getItem('uid');
	return `${path}?uid=${uid}`;
};
